/* eslint-disable react/no-multi-comp */
/* eslint-disable  react/jsx-no-bind */
/* eslint-disable  no-unused-vars */
/* eslint-disable  no-mixed-spaces-and-tabs */
/* eslint-disable  react/sort-comp */
/* eslint-disable  no-unused-vars */
/* eslint-disable react/no-will-update-set-state */
import React, { Component } from 'react'
import {  Col, FormGroup, Button, Row } from "react-bootstrap"
import {  Field, reduxForm, propTypes,formValueSelector,change } from 'redux-form'
import _ from 'lodash'
import Autocomplete from 'react-autocomplete'
import { CSVLink } from 'react-csv'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { URL } from '../../../../config'
import ModalWindow from '../../../../utils/modalwindow'
import { onlypositivenumbers } from '../../../../utils/helperfunctions/onlypositivenumbers'
import { 
	fetchSchool,deleteSchool,sortAscending,sortDescending,savingParticipantInfo,
	saveParticipantInfo,saveEventCertNumber,searchSchools,resetSchools,searchingSchools,setSelectedSchool,refreshParticipantRoster,gettingParticipantRoster
} from "../../../../redux/actions/action_participants"
import { fetchNonMemberSchool,notifySchoolNotFound, fetchAllSeasons } from "../../../../redux/actions/action_event"
import { renderChecboxField } from '../../../../modules/components/checkboxfieldcomponent'
import { green,blue,darkgray,gray,videoblue,warning,orange,forms } from "../../../../utils/constants"
import { isEqual } from "../../../../utils/helperfunctions"
import { lblattrs,lblattrs3 } from '../../../../utils/style'
import Gender from '../../../../utils/gender'
import { NoEligibleTeamMessage ,WrongGenderTeamMessage } from "../../../../utils/warningmessages"
import { getRequest } from "../../../../utils/httpRequest"
import { setupComplete } from '../Logic'
import {
	warningStyle,headerSection,eventMinsWarning,nonMember,jvSection,imageIconColor,searchBackground,headerLabel,
	btnSchoolSearch,jvDivision,jv, genderSection,btnSchoolNotFound,iconSchoolNotFound 
} from './style'
import '../../../../utils/css/nospinner.css'
import { Fields,SchoolNotFoundMessage,SchoolNotFoundNotificationSent,SchoolType,ListHeaders } from './Constants'
import { setParticipants,singleGenderMessage } from './Logic'
import { default as fields } from './fields'

const FormName = forms.eventinfo
const {
	sendingNotification,
	notificationSent
} = fields

class Participants extends Component {
	static propTypes = {
		...propTypes
	} 
	constructor(props) { 
		super(props)
		this.state = {
			sendingNotification:false,
			participantList:[]
		}    
		this.handleSchoolSearchChange = this.handleSchoolSearchChange.bind(this)
		this.handleSchoolSelect     = this.handleSchoolSelect.bind(this)
		this.getItemValue           = this.getItemValue.bind(this)
		this.renderItem             = this.renderItem.bind(this)
		this.retrieveSchoolsAsync   = _.debounce(this.retrieveSchoolsAsync,800)
		this.removeSchool           = this.removeSchool.bind(this)
		this.handleSaveParticipant  = this.handleSaveParticipant.bind(this)
		this.handleSortAscending    = this.handleSortAscending.bind(this)
		this.handleSortDescending   = this.handleSortDescending.bind(this)
		this.handleNotificationKnowledgment   = this.handleNotificationKnowledgment.bind(this)
		this.validateCorrectParticipantGender = this.validateCorrectParticipantGender.bind(this)
		this.notifyWrongTeams      =  this.notifyWrongTeams.bind(this)
		this.handleSubmit          = this.handleSubmit.bind(this)
		this.hasWrongTeamSelection = this.hasWrongTeamSelection.bind(this)
		this.noMenJV1Teams         = this.noMenJV1Teams.bind(this)
		this.noWomenJV1Teams            = this.noWomenJV1Teams.bind(this)
		this.handleGenerateList         = this.handleGenerateList.bind(this)
		this.handleNotifySchoolNotFound = this.handleNotifySchoolNotFound.bind(this)
		this.disableTeamGenderOption   = this.disableTeamGenderOption.bind(this)
		this.resetMenJV                = this.resetMenJV.bind(this)
		this.resetWomenJV              = this.resetWomenJV.bind(this)
		this.handleSaveEventCertNumber = this.handleSaveEventCertNumber.bind(this)
		this.saveParticipants          = this.saveParticipants.bind(this)
		this.handleOnCertNumberKeyPress = this.handleOnCertNumberKeyPress.bind(this)
	}
	componentDidMount() {
		const { dispatch } = this.props
		dispatch(change(FormName,'hasCheckedTeamSelection',false))
    this.props.fetchAllSeasons();

		const { participantschools,eventgenderwomen,eventgendermen,hasCheckedTeamSelection } = this.props
		// check if there is an existing participant list and if it contains the right genders   
		if ((participantschools.length > 0) && !hasCheckedTeamSelection) {	
			let wrongteams = null
			if(eventgendermen === false)
			{
				wrongteams = _.find(participantschools,['menteam',true])
				if(wrongteams !== undefined)
				{
					this.notifyWrongTeams()
				}
			}
			if(eventgenderwomen === false){
				wrongteams = _.find(participantschools,['womenteam',true])
				if(wrongteams !== undefined)
				{
					this.notifyWrongTeams()
				}
			}
		}
	}  
	UNSAFE_componentWillUpdate() {   
		const { sendingNotification } = this.state
		if(sendingNotification) {
			this.setState({ sendingNotification:false })
		}
	}
	componentWillUnmount() {
		this.saveParticipants()
	}
	//#endregion Lifecycle methods
	
	//#region Event handlers
	saveParticipants()
	{
		const { dispatch,prestineparticipantschools,participantschools,eventId,savingParticipantInfo,saveParticipantInfo } = this.props
		
		dispatch(change(FormName,'hasCheckedTeamSelection',false))

		const saveInfo   = ((prestineparticipantschools != undefined) && (participantschools != undefined)) == true ? !isEqual(prestineparticipantschools,participantschools):true
		// if information has not changed then there is no need to save it
		console.log('saveParticipants saveInfo',saveInfo)
		if (saveInfo) 
		{
			savingParticipantInfo()
			const participants = setParticipants(participantschools) 
			const details = {
				participants,
				eventId,
				step:5,
				resetParticipants:saveInfo
			}
			dispatch(saveParticipantInfo(details))
		}
		else 
		{
			dispatch(gettingParticipantRoster())
		  dispatch(refreshParticipantRoster(eventId))
		}
		
	}
	handleOnCertNumberKeyPress(evt)
	{
		if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57)
    	{
			evt.preventDefault()
    	}
	}
	handleSchoolSearchChange(e) {
		const { dispatch, schools,schoolNotFound } = this.props
		const minSearchLength = 3

		this.setState({
			value: e.target.value
		})
	
		if (e.target.value.length >=  minSearchLength) {
			const schoolName = e.target.value
		    this.retrieveSchoolsAsync(schoolName)
		}
		else {
			if ((schools != undefined) && (schools.length > 0) || schoolNotFound )
			{
				dispatch(resetSchools())
			}
		}
	}
	getSeasonYear(props)	{
		return props.eventSeasonSettings ? props.eventSeasonSettings.year : ''
	}
	retrieveSchoolsAsync(schoolName) {
		const seasonYear = this.getSeasonYear(this.props);
		const { dispatch } = this.props
		dispatch(searchingSchools())
		dispatch(searchSchools(schoolName, seasonYear))
	}
	handleSchoolSelect(val) {
		const seasonYear = this.getSeasonYear(this.props);
    	const { dispatch,schools,participantschools } = this.props
		this.setState({ value: val })
    
		const school = _.find(schools,{ 'name': val })
		const { usbcId, schoolType } = school
		console.log('Participant handleSchoolSelect usbcId participantschools',usbcId,participantschools)
		// dispatching selected school as a temp fix since / in school name is causing issues. 
		const temp = 'school'
		dispatch(setSelectedSchool(val))
		dispatch(fetchSchool(temp, usbcId, seasonYear, schoolType))
		this.setState({
			value:''
		})
	
	}
	handleSortAscending() {
		const { sortAscending } = this.props
		sortAscending()
	}
	handleSortDescending() {
		const { sortDescending } = this.props
		sortDescending()
	}
	handleGenerateList() {
		const { participantschools } = this.props
		const participantList = []
		const _this = this
		participantschools.map(function(school, index) {
			const { menteam ,womenteam ,menjv1team,womenjv1team,menjv2team,womenjv2team,name } = school
			participantList.push({
				name,
				menteam:menteam ? 'X':'',
				womenteam:womenteam ? 'X':'',
				menjv1team:menjv1team ? 'X':'',
				menjv2team:menjv2team ? 'X':'',
				womenjv1team:womenjv1team ? 'X':'',
				womenjv2team:womenjv2team ? 'X':''
			})
			_this.setState({ participantList }) 
		})
	}
	handleSaveParticipant(e) {
		e.preventDefault()
		const { participantschools,eventId,savingParticipantInfo,saveParticipantInfo } = this.props
		savingParticipantInfo()
		const participants = setParticipants(participantschools) 
		const details = {
			participants,
			eventId,
			step:5
		}
		saveParticipantInfo(details)
	}
	handleNotifySchoolNotFound(e) {
		e.preventDefault()
		const { eventId,dispatch } = this.props
		const school = {
			eventId,
			schoolName:this.state.value,
			directorId:eventId
		}
	  this.setState({ sendingNotification:true })
		dispatch(notifySchoolNotFound(school))
	}
	handleNotificationKnowledgment(e) {
		e.preventDefault()
		const { dispatch } = this.props
		dispatch(change(FormName, fields.notificationSent,false))
		this.setState({ value:'' })
	}
	//#endregion Supporting functions

	//#region Supporting Functions
	resetMenJV(school,jv1name,jv2name) {
		const { dispatch } = this.props

		if((school.menjv1team == true) && (school.menteam == false)){
			dispatch(change(FormName,jv1name,false))
		}
		if((school.menjv2team == true) && (school.menteam == false)){
			dispatch(change(FormName,jv2name,false))
		}
	}
	resetWomenJV(school,jv1name,jv2name) {
		const { dispatch } = this.props
		if((school.womenjv1team == true)&& (school.womenteam == false)){    
			dispatch(change(FormName,jv1name,false))
		}
		if((school.womenjv2team == true) && (school.womenteam == false)){
			dispatch(change(FormName,jv2name,false))
		}
	}
	renderItem(item, isHighlighted) {
		return (
			<div style={{ background: isHighlighted ? 'lightgray' : 'white' }} key={item.usbcId}>
				{item.name} 
			</div>   
		)
	}
	getItemValue(item) {
		return `${item.name}`
	}
	removeSchool(schoolId)
	{
		const { deleteSchool,dispatch } = this.props
		deleteSchool(schoolId)
	}
	notifyWrongTeams() {
		const { dispatch } = this.props
		dispatch(change(FormName,'wrongparticipantselection',true))
		dispatch(change(FormName,'hasCheckedTeamSelection',true))
	}
	handleSubmit() {
		console.log('inside handle submit')
	}
	displayWarning = (title,message,trigger) => {
		const { dispatch } = this.props  
		return (<ModalWindow 
		title={title} 
		trigger={trigger}
		message={message}
		dispatch={dispatch} />)
	}
	/* This function checks that in case users changes event to be unisex, that is either women or men, if a team selection had been made then
	we display a warning message stating there are, say, men teams in the participant list when the event is women only */
	validateCorrectParticipantGender(school)
	{
		const {  eventgendermen,eventgenderwomen } = this.props
		if((!eventgendermen && school.menteam) || (!eventgenderwomen && school.womenteam))
		{
			this.displayWarning('No eligible teams','This school does not have an eligible team to participate in this event.','norecordsfound' )
		}
	}
	hasWrongTeamSelection() {
		const { participantschools,eventgendermen,eventgenderwomen } = this.props
		let wrongteams = false

		if (eventgendermen && !eventgenderwomen) {
		const wrongwomen =  _.find(participantschools, { womenteam:true })
		if (wrongwomen) {
			wrongteams = true
		}
		} else if (eventgenderwomen && !eventgendermen ) {
			const wrongmen =   _.find(participantschools, { menteam:true })
			if (wrongmen) {
				wrongteams = true
			}
		}
	// console.log(`hasWrongTeamSelection return `, wrongteams)
		return wrongteams
	}
	noMenJV1Teams(school,jv2name) {
		if((school.menjv1team == false) && (school.menjv2team == true)){
			const { dispatch } = this.props
			dispatch(change(FormName,jv2name,false))
		}
	}
	noWomenJV1Teams(school,jv2name) {	 
		if((school.womenjv1team == false) && (school.womenjv2team == true)){
		const { dispatch } = this.props
		dispatch(change(FormName,jv2name,false))
		}
	}
	disableTeamGenderOption(school, gender) {
		const { eventgendermen, eventgenderwomen } = this.props
		const { hasmenteam,menteam,womenteam,haswomenteam,womennonmember,mennonmember } = school
		
		const genderMen   = (gender == Gender.Men)    // denotes men checkbox
		const genderWomen = (gender == Gender.Women)  // denotes women checkbox
		const bothGendersEvent = eventgendermen && eventgenderwomen
		const womenOnlyEvent = eventgenderwomen && !eventgendermen
		const menOnlyEvent = !eventgenderwomen && eventgendermen
		let disable  = false

		if (bothGendersEvent) {
			 if ((genderWomen && !haswomenteam && !womennonmember) || (genderMen && !hasmenteam && !mennonmember))
			 {
					disable  = true
			 }
		}
		else if (womenOnlyEvent) {
			 if (genderWomen) 
			 {
          disable = true
			 }
			 else if (genderMen) 
			 {
				 if (( menteam && !womenteam) || (!menteam))
				 {
					 disable = true
				 }
			 }
		}
		else if (menOnlyEvent) {
			if (genderMen) 
			{
        disable = true
			}
			else if (genderWomen) 
			{
				if (( womenteam && !menteam) || (!womenteam))
				{
					disable = true
				}
			}
		}
		
		return disable
	}
	disableTeamGenderOption1(school, gender) {
		const { eventgendermen, eventgenderwomen } = this.props
		const { hasmenteam,menteam,womenteam,haswomenteam } = school
		const genderMen = (gender == Gender.Men)
		// when adding schools to an event, event participants, we disabe the team gender selectio option in certain situations:

		// 1. Event is for a specific gender, then if school has that gender check the option and disable it, disable the other gender team if school has it
	
		const notBothGenderPresent = genderMen ? (menteam && !womenteam):(womenteam && !menteam)
		const oppositeGenderEvent  = genderMen? !eventgendermen : !eventgenderwomen
		const schoolDoesNotHaveGenderTeam = genderMen ? !hasmenteam: !haswomenteam
		const wrongGender = genderMen ? (	(eventgenderwomen && !eventgendermen && menteam) || (menteam && !womenteam) ) : 
																		(	(eventgendermen && !eventgenderwomen && womenteam) || (womenteam && !menteam) )
		console.log('genderMen,notBothGenderPresent,oppositeGenderEvent,schoolDoesNotHaveGenderTeam,wrongGender',genderMen,notBothGenderPresent,oppositeGenderEvent,schoolDoesNotHaveGenderTeam,wrongGender)
		return ((oppositeGenderEvent || notBothGenderPresent || schoolDoesNotHaveGenderTeam) && (!wrongGender) || wrongGender)
	}
	handleSaveEventCertNumber() {
	   const { eventId,eventcertnumber,prestineeventcertnumber,saveEventCertNumber } = this.props
	
		 if(prestineeventcertnumber != eventcertnumber){
			 const certdetails = {
				 eventId,
				 eventCertificationNumber:eventcertnumber
			 }
			 saveEventCertNumber(certdetails)
		 }
	}
	//#endregion Supporing Functions
	render() {
		const { 
			handleSubmit,  previousPage, prestineparticipantschools,participantschools,eventname, eventcertnumber, eventgendermen,eventgenderwomen ,
			eventjvgendermen,eventjvgenderwomen , norecordsfound,wrongparticipantselection, sorted,eventSeasonSettings,
			schoolNotFoundNotfSent,savingparticipants,standardgames,bakergames,schools,searching,schoolNotFound
		} = this.props 
		const _this = this
		const { handleSaveEventCertNumber } = this
		const { sendingNotification } = this.state      
		const _removeSchool = this.removeSchool
		const _numteams     = participantschools.length
		const imageIcon     = searching == true ? 'fa fa-spinner fa-spin':'fa fa-university'
	  const disableSave   = isEqual(prestineparticipantschools,participantschools)
		
		return (
			
			<div style={{ marginTop:'1%' }}>
				{  norecordsfound  && this.displayWarning(NoEligibleTeamMessage.title,NoEligibleTeamMessage.message,'norecordsfound')  }    
				{  wrongparticipantselection  && 
							(this.displayWarning('Wrong gender schools',`This is a ${singleGenderMessage(eventgendermen,eventgenderwomen)}, but your team selection list contains ${eventgendermen ? 'women':'men'} teams. Please correct this issue before proceeding to the next step.`,'wrongparticipantselection' ))
				}       
				<form className="form-horizontal" onSubmit={handleSubmit} onKeyPress={e => { if (e.key === 'Enter') e.preventDefault()}}>
					<Col md={12} lg={12} style={{ padding:'0',marginLeft:'0px' }}>
						<div style={headerSection}> 
							<FormGroup style={headerLabel}>
								<h4 className='col-sm-4 col-md-5 col-lg-5' style={{ color:videoblue }}>{' '}Participants - <span style={{ color:'green' }}>{_.startCase(_.toLower(eventname))}   </span></h4>
								<span style={{ display: !(this.props.eventgendermen && this.props.eventgenderwomen) ? 'block':'none', fontSize:'20px',color:warning }}>
									{		
										singleGenderMessage(eventgendermen,eventgenderwomen)
									}
								</span>                       
								<br/>
							</FormGroup>
							<FormGroup>
							{ eventSeasonSettings && 
								(<Col sm={ 12 } style={{ marginBottom:'20px' }} className='text-center'>
									<label className="control-label" style={eventMinsWarning}>
										<i className="fa fa-exclamation-triangle" aria-hidden="true"  />&nbsp; To be eligible for ranking points, event minimums are {eventSeasonSettings.minMenTeams} men’s teams from different schools and/or {eventSeasonSettings.minWomenTeams} women’s teams from different schools. 
									</label>
									</Col>)
							}
							</FormGroup>
							<FormGroup  style={{  marginTop:'-50px' }}>
								<label className={lblattrs}>Event Certification Number</label>                           
								<Col sm={8 } md={5} lg={4}>                                  
									<Field
										type='number'
										name={Fields.EVENTCERTNUMBER }
										component='input'
										className="form-control no-spinners"
										placeholder='Type event number'
										max='99999999'
										//parse={ onlypositivenumbers }
										onKeyPress={this.handleOnCertNumberKeyPress}
										onBlur={ handleSaveEventCertNumber }
									/>
								</Col> 
								{ norecordsfound && 
								(<Col sm={3} md={3} lg={3}>
									<Button style={{ backgroundColor:orange, color:'white', minHeight:'36px' }} onClick={this.handleAddEvent} disabled={this.state.addNewEventMode}>
										<i className="fa fa-exclamation-circle" aria-hidden="true"  />&nbsp;&nbsp; Can&#39;t find school
									</Button>
									</Col>)
								}                                                  
							</FormGroup>                       
							<FormGroup> 
								<label className={lblattrs}>Participating school</label>     
								<Col sm={4}>                               
									<Autocomplete
										getItemValue={this.getItemValue}
										items={schools}
										renderItem={this.renderItem}                                  
										value={this.state.value}
										onChange={this.handleSchoolSearchChange}
										onSelect={this.handleSchoolSelect}
										selectOnBlur
										inputProps= {
											{ 
												placeholder:'Type school name (min 3 characters)',
												className:'form-control' ,
												zindex:'10'                               
											}
										}
										wrapperStyle = {
											{ 
												width:'100%'      
											}
										}
										menuStyle = {
											{ 
												zIndex:'10' 
											}
										}
									/>                          
								</Col> 
								{ schoolNotFound && !sendingNotification &&
									(<button className="btn btn-danger" onClick={this.handleNotifySchoolNotFound} style={btnSchoolNotFound}>
											<i className='fa fa-ban' aria-hidden="true" style={iconSchoolNotFound} />&nbsp;&nbsp;{SchoolNotFoundMessage}
									</button>) 
								}
								{
									sendingNotification  && !schoolNotFoundNotfSent &&
									(	
										<div style={{ color:blue, fontSize:'20px', margin:'15px', marginTop:'0' }}>
											<p>	<i className='fa fa-spinner fa-spin' aria-hidden='true'  />&nbsp;&nbsp;Notifying USBC administrators...</p>
										</div>
									)
								}
								{
									schoolNotFoundNotfSent && 
									(
										<button className="btn btn-warning" onClick={this.handleNotificationKnowledgment} style={{ ...btnSchoolNotFound, marginTop:'-17px',marginLeft:'6px' }}>
											<i className='fa fa-ban' aria-hidden="true" style={iconSchoolNotFound} />&nbsp;&nbsp;{SchoolNotFoundNotificationSent} <br/> Click here to continue...
										</button>
									) 
								}
							
								{
									(!schoolNotFound) && (!sendingNotification) && (!schoolNotFoundNotfSent) &&	(
										<section>
										<Col sm={1}>
											<span className="input-group-btn" sm={1}>
												<button 
													type="button" 
													className="btn btn-default" 
													style={{ ...btnSchoolSearch,...searchBackground }}
												> 
													<i className={imageIcon} aria-hidden="true" style={imageIconColor} />
												</button>
											</span>
										</Col>
										<Col sm={4}>
											<span style={warningStyle}>* denotes non-member teams.</span><br/>
											<span style={warningStyle}>** denotes wrong gender in your participant list.</span>
										</Col>
									</section>
									)
								}
							</FormGroup>
						</div>    
			  
				{                     
					(_numteams > 0) && 
					
					<div style={{ border:`1px solid ${gray}`, marginBottom:'15px' , textAlign:'center' }}>
					<Row  style={{ marginTop:'10px' }}>
					<FormGroup>
						<Col sm={8 } md={3} lg={1} className="col-md-offset-2 col-lg-offset-2">
							<span className="input-group-btn">
							<button 
								type="button" 
								className="btn btn-default" 
								style={{ width:'12px',height:'10px',padding:'0 0 5px 0', borderWidth:'0' }} 
								onClick={this.handleSortAscending}
							>
							<i className="fa fa-sort-up" aria-hidden="true"   />
							</button>
							</span>
							<span className="input-group-btn">
							<button 
								type="button" 
								className="btn btn-default" 
								style={{ width:'12px',height:'10px', borderWidth:'0', marginTop:'-10px', padding:'0' }} 
								onClick={this.handleSortDescending}
							> 
								<i className="fa fa-sort-down" aria-hidden="true"   />
							</button>
							</span>                                 
						</Col> 
						<Col  sm={2}>
							<button className="btn btn-primary" onClick={this.handleSaveParticipant} disabled={disableSave}>
								<i className={savingparticipants ?"fa fa-spinner fa-spin":"fa	fa-floppy-o"} aria-hidden="true"/>
									&nbsp;&nbsp;Save Participants
							</button>
						</Col>
						<Col sm={ 3 }>
						<div style={{ marginTop:'5px' }}>
							<CSVLink 
								data={this.state.participantList} 
								headers={ ListHeaders }
								filename={`${_.startCase(_.toLower(eventname))} Tournament Participant List.csv`}
								target='_blank' 
								style={{ border:`1px solid ${darkgray}`,padding:'7px',borderRadius:'3px',color:'green' }}  
								                                  
							>
								<i className="fa fa-file-excel-o" aria-hidden="true" />{'  '}<span onClick={this.handleGenerateList}>&nbsp;Generate Participant List (.csv)</span>                                    
							</CSVLink>
							</div>
						</Col>    
					</FormGroup> 
				</Row>
		{    
				participantschools.map(function(school, index) {
			
				const objectkey = `participantschools.${index}`
				
				const { mennonmember,womennonmember } = school                                     
				const mcname   = `${objectkey}.menteam`
				const wcname    = `${objectkey}.womenteam`
				const mcjv1name = `${objectkey}.menjv1team`
				const wcjv1name = `${objectkey}.womenjv1team`
				const mcjv2name = `${objectkey}.menjv2team`
				const wcjv2name = `${objectkey}.womenjv2team` 
				const button =  <Button bsStyle="link" style={{ paddingTop:'13px' }} onClick={() => { _removeSchool(index)}}>Remove</Button>

				return (                                
						<FormGroup  key={index} style={{ backgroundColor:index % 2 == 0 ? '#fafafa':'',marginLeft:'20px',marginRight:'20px' }}>
							<label className={lblattrs3} style={{ fontSize:'90%' }}> {_numteams - index}.  {((school.womenteam && !eventgenderwomen) || (school.menteam && !eventgendermen))? <span style={{ color:'red' }}>**</span>:''} {school.name}</label>
							<Col sm={9}  >   
									<div  className='col-lg-3 col-md-3' style={genderSection} >                                       
										{mennonmember &&  (<span style={nonMember}>*&nbsp;</span>)}
										<Field
											label = 'Men'
											name= {mcname}  
											id={mcname}
											value={ school.menteam }               
											checked={  school.menteam  }
											component={  renderChecboxField  } 
											onChange={_this.resetMenJV(school,mcjv1name,mcjv2name)}
											disabled = {_this.disableTeamGenderOption(school,Gender.Men)}           
											field={school}                                                          
										/>
										{womennonmember &&  (<span style={nonMember}>*&nbsp;</span>) } 
										<Field
											label = 'Women'
											name= {wcname}  
											id={wcname}
											value    = { school.womenteam}               
											checked={ school.womenteam }
											component={  renderChecboxField  } 
											onChange={_this.resetWomenJV(school,wcjv1name,wcjv2name)}
											disabled = {_this.disableTeamGenderOption(school,Gender.Women)}   
											field={school}                                                               
										/> 
									</div> 
									{
										eventjvgendermen && school.menteam && 
											(<div style={jvSection} className={jvDivision}>
													<span style={jv}>Men</span>
												<Field
													label = 'JV1'
													name= {mcjv1name}  
													id={mcjv1name}
													value={ school.menjv1team }  
													checked={ school.menjv1team == true  }  
													onClick={_this.noMenJV1Teams(school,mcjv2name)}           
													component={  renderChecboxField  } 
													disabled={((!school.menteam) && (!mennonmember)) || (!eventgendermen && !school.menteam)}       
													field={school}                                                          
												/>
											{ 
												school.menjv1team  && 
												(<Field
													label = 'JV2'
													name= {mcjv2name}  
													id={mcjv2name}
													value    = { school.menjv2team}               
													checked={ school.menjv2team == true  }
													component={  renderChecboxField  } 
													disabled={ ((!school.menteam) && (!mennonmember)) || (!eventjvgendermen)}     
													field={school}                                                               
												/>)
											}
									</div>)
								}
								{
									eventjvgenderwomen && school.womenteam  && 
											(<div style={ jvSection } className={jvDivision}>
										<span style={jv}>Women</span>
										<Field
											label = 'JV1'
											name= {wcjv1name}  
											id={wcjv1name}
											value={ school.womenjv1team }  
											checked={ school.womenjv1team == true }     
											onClick={_this.noWomenJV1Teams(school,wcjv2name)}         
											component={  renderChecboxField  } 
											disabled={  (( !womennonmember) && ( !school.womenteam)) || (!eventjvgenderwomen)}       
											field={school}    																																																											 
										/>
									{
										school.womenjv1team && (<Field
										label = 'JV2'
										name= {wcjv2name}  
										id={wcjv2name}
										value    = { school.womenjv2team  } 
										checked={ school.womenjv2team == true  }                
										component={  renderChecboxField  } 
										disabled={ (( !school.womenteam) && (!womennonmember)) || (!eventjvgenderwomen)}     
										field={school} 
										/> )
									}					 
							</div>)}
							<div style={{ maxWidth:'50px' }} className='col-md-1'>
								{button}
							</div> 
						</Col>        
					</FormGroup>)
				})
			}
		</div>
		}
		</Col>
		<Col sm={12} md={12} lg={12} >
			<button 
				type="button" 
				className="btn btn-primary pull-left previous" 
				onClick={previousPage} 
				style={{ fontSize:'120%',fontWeight:'bold' }}><i className="fa fa-caret-left" aria-hidden="true"  />&nbsp;&nbsp;Previous
			</button>
			<button 
				type="submit" className="btn btn-primary pull-right next" 
				style={{ minWidth:'120px', fontSize:'120%',fontWeight:'bold' }} 
				disabled = { this.hasWrongTeamSelection() || 
					participantschools.length == 0 || 
					!setupComplete(bakergames,standardgames) 
				} 
				tooltip={(this.hasWrongTeamSelection() || participantschools.length == 0) ? 'hello':''}>
					<i className='fa fa-caret-right' aria-hidden="true"  />&nbsp;&nbsp; Next
			</button>              
		</Col>
		</form>
	</div>)
	}
}
Participants.propTypes = {
	availablerankings:PropTypes.array,
    seasonId:PropTypes.number,
	handleSubmit:PropTypes.func,
	searchSchools:PropTypes.func,
	resetSchools:PropTypes.func,
	initialize:PropTypes.func,
	dispatch:PropTypes.func,
	previousPage:PropTypes.func,
	savingParticipantInfo:PropTypes.func,
	saveEventCertNumber:PropTypes.func,
	saveParticipantInfo:PropTypes.func,
	fetchSchool:PropTypes.func,
	fetchNonMemberSchool:PropTypes.func,
	deleteSchool:PropTypes.func,
	sortAscending:PropTypes.func,
	sortDescending:PropTypes.func,
	notifySchoolNotFound:PropTypes.func,
	eventname:PropTypes.string,
	eventcertnumber:PropTypes.string,
	prestineeventcertnumber:PropTypes.string,
	searchMode:PropTypes.bool,
	eventId:PropTypes.number,
	participantschools:PropTypes.array,
	prestineparticipantschools:PropTypes.array,
	schools:PropTypes.array,
	eventgendermen:PropTypes.bool,
	eventgenderwomen:PropTypes.bool,
	eventjvgendermen:PropTypes.bool,
	eventjvgenderwomen:PropTypes.bool,
	norecordsfound:PropTypes.bool,
	sorted:PropTypes.bool,
	hasCheckedTeamSelection:PropTypes.bool,
	wrongparticipantselection:PropTypes.bool,
	eventSeasonSettings:PropTypes.object,
	schoolNotFoundNotfSent:PropTypes.bool,
	memberidsuffix:PropTypes.bool,
	memberidprefix:PropTypes.bool,
	savingparticipants:PropTypes.bool,
	standardgames:PropTypes.number,
	bakergames: PropTypes.number,
	menTeamUSBCId:PropTypes.string,
	womenTeamUSBCId:PropTypes.string,
	searching:PropTypes.bool,
	searchingSchools:PropTypes.func,
	schoolNotFound:PropTypes.bool,
	refreshParticipantRoster:PropTypes.func,
	gettingParticipantRoster:PropTypes.func,
  fetchAllSeasons:PropTypes.func
}
function validate(values) {
	const errors = {}
	if (values.participantschools.length === 0) {
		errors.participantschools = 'Please specify particiant schools'
	}
	return errors
}
function mapStateToProps(state,ownProps) { 
	const formName =  ownProps.form
	const selector = formValueSelector(formName)
	const eventcertnumber = selector(state,Fields.EVENTCERTNUMBER )
	const prestineeventcertnumber = selector(state,Fields.PRESTINEEVENTCERTNUMBER )
	const searchMode = selector(state,'searchMode')
	const participantschools = selector(state,'participantschools')
	const prestineparticipantschools = selector(state,'prestineparticipantschools')
	const eventname  = selector(state,'eventname')
	const eventgendermen = selector(state,'eventgendermen')
	const eventgenderwomen = selector(state,'eventgenderwomen')
	const eventjvgendermen = selector(state,'eventjvgendermen')
	const eventjvgenderwomen = selector(state,'eventjvgenderwomen')
	const norecordsfound = selector(state,'norecordsfound')
	const sorted = selector(state,'sorted')
	const hasCheckedTeamSelection = selector(state,'hasCheckedTeamSelection')
	const wrongparticipantselection = selector(state,'wrongparticipantselection')
	const eventId = selector(state,'eventId')
	const eventSeasonSettings = selector(state,'eventSeasonSettings')
	const schoolNotFoundNotfSent = selector(state,fields.notificationSent)
	const	memberidprefix = selector(state,fields.sendingNotification)
	const	memberidsuffix = selector(state,fields.sendingNotification)
	const savingparticipants = selector(state,fields.savingparticipants)
	const standardgames = selector(state,'standardgames')
	const bakergames  = selector(state,'bakergames')
	const menTeamUSBCId = selector(state,'menTeamUSBCId')
	const womenTeamUSBCId = selector(state,'womenTeamUSBCId')
	const schools  = selector(state,'schools')
	const searching = selector(state,'searching')
	const schoolNotFound = selector(state,'schoolNotFound')
    
	return {
		eventId,
		eventcertnumber,
		prestineeventcertnumber,
		searchMode,
		participantschools,
		prestineparticipantschools,
		eventname,
		eventgendermen,
		eventgenderwomen,
		eventjvgendermen,
		eventjvgenderwomen,
		norecordsfound,
		sorted,
		hasCheckedTeamSelection,
		wrongparticipantselection,
		eventSeasonSettings,
		schoolNotFoundNotfSent,
		memberidprefix,
		memberidsuffix,
		savingparticipants,
		standardgames,
		bakergames,
		womenTeamUSBCId,
		menTeamUSBCId,
		schools,
		searching,
		schoolNotFound
	}
}  
function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		saveParticipantInfo,
		saveEventCertNumber,
		savingParticipantInfo,
		fetchSchool,
		fetchNonMemberSchool,
		deleteSchool,
		sortAscending,
		sortDescending,
		notifySchoolNotFound,
		searchSchools,
		resetSchools,
		searchingSchools,
		refreshParticipantRoster,
		gettingParticipantRoster,
    fetchAllSeasons,
	},dispatch)
}
export default reduxForm({
	validate,
	form:FormName,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: false
})(connect(mapStateToProps,mapDispatchToProps)(Participants))




// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Participants/index.js